/**
 * Studio — Publications audit log.
 */

import { Loader2 } from "lucide-react";
import { AppShell } from "../../layouts/AppShell";
import { usePublications } from "../../../api/opsV2/hooks";

type StudioPublicationsPageProps = {
  userName?: string;
  onBack?: () => void;
};

export function StudioPublicationsPage({
  userName = "Utilisateur",
  onBack,
}: StudioPublicationsPageProps) {
  const { data: events, loading, error, refetch } = usePublications({ limit: 50 });

  return (
    <AppShell
      userName={userName}
      topbar={
        <div className="flex items-center gap-4">
          {onBack && (
            <button type="button" onClick={onBack} className="text-sm text-muted hover:text-text">
              Studio
            </button>
          )}
          <span className="text-sm font-medium text-text">Publications</span>
        </div>
      }
    >
      <div className="ds-container py-6">
        <h1 className="text-xl font-semibold text-text mb-2">Historique des publications</h1>
        <p className="text-sm text-muted mb-4">
          Audit des publications (Rule Sets, etc.).
        </p>

        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted py-8">
            <Loader2 className="h-4 w-4 animate-spin" />
            Chargement…
          </div>
        )}
        {error && (
          <div className="rounded-lg border border-destructive/50 bg-destructive/5 p-4 text-sm text-destructive">
            {error.message}
            <button type="button" onClick={() => refetch()} className="ml-2 underline">
              Réessayer
            </button>
          </div>
        )}
        {!loading && !error && (!events || events.length === 0) && (
          <p className="text-sm text-muted py-6">Aucune publication.</p>
        )}
        {!loading && !error && events && events.length > 0 && (
          <div className="rounded-md border border-border overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border bg-muted/30">
                  <th className="text-left p-3 font-medium text-text">Date</th>
                  <th className="text-left p-3 font-medium text-text">Entité</th>
                  <th className="text-left p-3 font-medium text-text">Action</th>
                </tr>
              </thead>
              <tbody>
                {events.map((e) => (
                  <tr key={e.id} className="border-b border-border/50 hover:bg-muted/20">
                    <td className="p-3 text-muted">
                      {new Date(e.created_at).toLocaleString("fr-CA", { dateStyle: "short", timeStyle: "short" })}
                    </td>
                    <td className="p-3">
                      <span className="text-muted">{e.entity_type}</span>
                      <span className="ml-1 font-mono text-xs">{e.entity_id.slice(0, 8)}…</span>
                    </td>
                    <td className="p-3 font-medium text-text">{e.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AppShell>
  );
}
